import { createHostModule } from '@wix/sdk-runtime/host-modules';
export const windowRuntime = createHostModule({
    browserLocale: ({ channel }) => function browserLocale(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'browserLocale',
            args,
        });
    },
    formFactor: ({ channel }) => function formFactor(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'formFactor',
            args,
        });
    },
    referrer: ({ channel }) => function referrer(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'referrer',
            args,
        });
    },
    viewMode: ({ channel }) => function viewMode(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'viewMode',
            args,
        });
    },
    copyToClipboard: ({ channel }) => function copyToClipboard(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'copyToClipboard',
            args,
        });
    },
    getAppPageData: ({ channel }) => function getAppPageData(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'getAppPageData',
            args,
        });
    },
    getBoundingRect: ({ channel }) => function getBoundingRect(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'getBoundingRect',
            args,
        });
    },
    getCurrentGeolocation: ({ channel }) => function getCurrentGeolocation(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'getCurrentGeolocation',
            args,
        });
    },
    getRouterData: ({ channel }) => function getRouterData(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'getRouterData',
            args,
        });
    },
    openAppLightbox: ({ channel }) => function openAppLightbox(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'openAppLightbox',
            args,
        });
    },
    openLightbox: ({ channel }) => function openLightbox(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'openLightbox',
            args,
        });
    },
    openModal: ({ channel }) => function openModal(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'openModal',
            args,
        });
    },
    postMessage: ({ channel }) => function postMessage(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'postMessage',
            args,
        });
    },
    registerEventListener: ({ channel }) => function registerEventListener(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'registerEventListener',
            args,
        });
    },
    scrollBy: ({ channel }) => function scrollBy(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'scrollBy',
            args,
        });
    },
    scrollTo: ({ channel }) => function scrollTo(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'scrollTo',
            args,
        });
    },
    trackEvent: ({ channel }) => function trackEvent(...args) {
        return channel.invoke({
            namespace: 'window',
            method: 'trackEvent',
            args,
        });
    },
});
//# sourceMappingURL=window.runtime.js.map